import { inject, Injectable, OnDestroy } from '@angular/core';
import { IAddLoadingOptions, IGetLoadingOptions, IRemoveLoadingOptions, IsLoadingService } from './is-loading.service';
import { Observable, Subscription } from 'rxjs';

import { LogService } from '../log.service';
import { _BaseLoadingService } from './_base-loading.service';
import { LoadKey, loadKey } from './models/loadKey';

@Injectable({
    providedIn: 'root'
})
export class LoadingService 
    extends _BaseLoadingService
{
    
    constructor() {
        super(null);
    }

    add(options?: IAddLoadingOptions): void {
        this._isLoadingService.add(options);
    }

    addCount(value: number): void {
        super._addCount(value);
    }

    reset(): void {
        this.clear({key: Object.values(loadKey)});
    }

    clear(options?: IAddLoadingOptions): void {
        this._isLoadingService.clear(options);
    }

    isBaseLoading$(options?: IGetLoadingOptions): Observable<boolean> {
        return this._isLoadingService.isLoading$(options);
    }

    remove(options?: IRemoveLoadingOptions): void {
        this._isLoadingService.remove(options);
    }

    removeCount(value: number): void {
        super._removeCount(value);
    }
}
